/* eslint-disable no-unused-vars */
import createComponent from 'ui/base/createComponent';
import { Select } from '@material-ui/core';
import mapError from 'ui/base/mapError';

const mapProps = ({
    input: { onChange, value, onBlur, ...inputProps },
    meta,
    onChange: onChangeFromField,
    muiInput,
    ...props
}) => ({
    ...mapError(props),
    ...inputProps,
    ...props,
    input: muiInput,
    value: value,
    onChange: (event) => {
        onChange(event.target.value);
        if (onChangeFromField) {
            onChangeFromField(event.target.value);
        }
    },
    onBlur: () => onBlur(value),
});

export default createComponent(Select, mapProps);
